var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3214 3.71428H20.25V13H19.3214V15.7857C19.3214 16.2985 18.9057 16.7143 18.3929 16.7143H1.67857C1.16574 16.7143 0.75 16.2985 0.75 15.7857V0.92857C0.75 0.41574 1.16574 0 1.67857 0H18.3929C18.9057 0 19.3214 0.41574 19.3214 0.92857V3.71428ZM17.4643 13H11.8929C9.32871 13 7.24999 10.9213 7.24999 8.35713C7.24999 5.79296 9.32871 3.71428 11.8929 3.71428H17.4643V1.85714H2.60714V14.8571H17.4643V13ZM18.3929 11.1428V5.57142H11.8929C10.3543 5.57142 9.10715 6.81859 9.10715 8.35713C9.10715 9.89568 10.3543 11.1428 11.8929 11.1428H18.3929ZM11.8929 7.42856H14.6786V9.2857H11.8929V7.42856Z",
    fill: "#5B73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.17c55ba00c23256d05619006a692bab3.svg";
export { ForwardRef as ReactComponent };